<section class="rep" aria-label="Failed deliveries">
  <div class="rep__toolbar">
    <app-search-input label="Search failed deliveries"
      class="rep__search"
      placeholder="Search by number or name"
      (valueChange)="onSearch($event)"
    />

    <app-status-filter
      label="Failure"
      allLabel="All failures"
      [options]="statusOptions"
      [selectedValue]="state"
      (selectionChange)="onStateChange($event)"
    />

    <span class="rep__spacer"></span>

    <button
      type="button"
      class="bk-btn bk-btn--ghost"
      [disabled]="exporting || status !== 'ready' || total === 0"
      (click)="downloadCsv()"
    >
      <span class="bk-sym" aria-hidden="true">{{ exporting ? "hourglass_empty" : "download" }}</span>
      {{ exporting ? "Preparing file…" : "Download failed numbers" }}
    </button>
  </div>

  <!-- Always in the page, so screen readers announce each new notice. -->
  <p class="rep__notice" role="status" [attr.data-tone]="noticeTone" [class.bk-sr-only]="!notice">{{ notice }}</p>

  <div class="bk-panel rep__panel">
    <data-table
      label="Failed deliveries"
      [seamless]="true"
      [loading]="status === 'loading'"
      [resizable]="false"
      [maxHeight]="'640px'"
      [skeletonColumns]="6"
    >
      @if (status === "error") {
        <app-empty-state
          icon="cloud_off"
          message="The failure list could not be loaded."
          hint="Check your connection, then try again."
          actionLabel="Try again"
          actionIcon="refresh"
          (action)="reload()"
        />
      } @else if (rows.length > 0) {
        <table class="bk-log">
          <thead>
            <tr>
              <th scope="col">Recipient</th>
              <th scope="col" class="col-msg">Message</th>
              <th scope="col" class="col-status">Status</th>
              <th scope="col" class="col-country">Country</th>
              <th scope="col" class="num col-when">Failed at</th>
              <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.key) {
              <tr
                [class.is-link]="!!row.messageUuid"
                [attr.tabindex]="row.messageUuid ? 0 : null"
                (click)="open(row)"
                (keydown.enter)="openFromKeyboard($event, row)"
              >
                <td class="col-lead">
                  <span class="who">
                    <span class="who__main">{{ row.name || row.number || "Unknown recipient" }}</span>
                    @if (row.name && row.number) {
                      <span class="who__sub">{{ row.number }}</span>
                    }
                  </span>
                </td>
                <td class="col-msg">
                  <span class="msg-cell">{{ row.subject }}</span>
                </td>
                <td class="col-status">
                  <span class="status-stack">
                    <app-status [text]="row.statusLabel" [status]="row.statusTone" />
                    @if (row.reason) {
                      <span class="status-stack__why">{{ row.reason }}</span>
                    }
                  </span>
                </td>
                <td class="quiet col-country">{{ row.country || "—" }}</td>
                <td class="num quiet col-when" [attr.title]="row.exact || null">{{ row.when }}</td>
                <td class="col-actions">
                  <span class="bk-row-actions">
                    @if (row.number) {
                      <button
                        type="button"
                        class="bk-icon-btn"
                        [attr.aria-label]="copiedKey === row.key ? 'Number copied' : 'Copy number'"
                        [matTooltip]="copiedKey === row.key ? 'Copied' : 'Copy number'"
                        (click)="$event.stopPropagation(); copyNumber(row)"
                        (keydown.enter)="$event.stopPropagation()"
                      >
                        <span class="bk-sym" aria-hidden="true">{{ copiedKey === row.key ? "check" : "content_copy" }}</span>
                      </button>
                    }
                    @if (row.messageUuid) {
                      <button
                        type="button"
                        class="bk-icon-btn"
                        aria-label="Open delivery report"
                        matTooltip="Open delivery report"
                        (click)="$event.stopPropagation(); open(row)"
                        (keydown.enter)="$event.stopPropagation()"
                      >
                        <span class="bk-sym" aria-hidden="true">monitoring</span>
                      </button>
                      <span class="bk-sym row-go" aria-hidden="true">chevron_right</span>
                    }
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else if (term && filtered) {
        <app-empty-state [query]="term" [filtered]="true" (clear)="clearFilters()" />
      } @else if (term) {
        <app-empty-state [query]="term" />
      } @else if (filtered) {
        <app-empty-state [filtered]="true" (clear)="clearFilters()" />
      } @else {
        <app-empty-state
          icon="task_alt"
          [message]="emptyLine"
          hint="Every receipt in this period is delivered or still on its way. Failures show here as soon as a network reports one."
        />
      }
    </data-table>
  </div>

  @if (status !== "error" && total > 0) {
    <div class="rep__foot">
      <app-pagination
        [currentPage]="page"
        [totalPages]="totalPages"
        [totalItems]="total"
        [pageSize]="size"
        [loading]="status === 'loading'"
        (changePage)="onPage($event)"
        (pageSizeChange)="onPageSize($event)"
      />
    </div>
  }
</section>
